import styled from 'styled-components';

import { BadgePosition } from './AvatarWithBadge.types';
import { getBadgePositionCss } from './AvatarWithBadge.utils';

export const Container = styled.div`
  display: inline-flex;
  position: relative;
`;

export const BadgeStyled = styled.div<{ $position: BadgePosition }>`
  position: absolute;

  ${(props) => getBadgePositionCss(props.$position)}
`;
